import { ArrowDownIcon, ArrowUpIcon, ExchangeIcon } from '@components'
import cn from '@integrations/classnames'
import { TransactionDirections } from 'mmfintech-backend-api'
import { fetchLastChunk, tr } from 'mmfintech-commons'
import styles from './TransactionsTable.module.scss'

interface Props {
  direction?: string
  trnTypeLocalizationKey?: string
}

/** Type column content: a direction badge (in, out, or both ways) and the localized type name. */
function TransactionTypeCell({ direction, trnTypeLocalizationKey }: Props) {
  return (
    <span className={cn(styles['type-cell'], 'type-cell')}>
      <span className={cn(styles['type-icon'], 'type-icon')}>
        {direction === TransactionDirections.DEPOSIT ? (
          <ArrowDownIcon />
        ) : direction === TransactionDirections.WITHDRAW ? (
          <ArrowUpIcon />
        ) : (
          <ExchangeIcon />
        )}
      </span>
      <span className={cn(styles['type-label'], styles['ellipsis'], 'type-label')}>
        {tr(trnTypeLocalizationKey, fetchLastChunk(trnTypeLocalizationKey))}
      </span>
    </span>
  )
}

export default TransactionTypeCell
